import {
  ShoppingCart,
  LeafyGreen,
  Settings,
  SunMedium,
  Warehouse,
  Hammer,
  Flame,
  Coffee,
  MapPinHouse,
  User2,
} from 'lucide-react';

const homeOptions = [
  {
    title: 'Source',
    icon: ShoppingCart,
    to: '/source',
  },
  {
    title: 'Pre-Process',
    icon: LeafyGreen,
    to: '/pre-process',
  },
  {
    title: 'Process',
    icon: Settings,
    to: '/process',
  },
  {
    title: 'Drying',
    icon: SunMedium,
    to: '/drying-lots',
  },
  {
    title: 'Storage',
    icon: Warehouse,
    to: '/storage-lots',
  },
  {
    title: 'Hull',
    icon: Hammer,
    to: '/hull',
    disabled: true,
  },
  {
    title: 'Roast',
    icon: Flame,
    to: '/roast',
    disabled: true,
  },
  {
    title: 'Cup',
    icon: Coffee,
    to: '/cup',
    disabled: true,
  },
  {
    title: 'Estates',
    icon: MapPinHouse,
    to: '/estates',
    role: 'admin',
  },
  {
    title: 'Users',
    icon: User2,
    to: '/admin',
    // to: '/users',
    role: 'admin',
  },
];

export const getFilteredHomeOptions = userRole => {
  return homeOptions.filter(option => {
    if (!option?.role) return true;

    return option?.role.toLowerCase() === userRole?.toLowerCase();
  });
};
